import { ZoneImageState } from './authentication-config';

export const clearAiIdentifyTransientState = (
  zoneImages: ZoneImageState,
  revokeBlobUrl: (url?: string) => void,
): ZoneImageState => {
  void revokeBlobUrl;

  const nextState: ZoneImageState = {};
  Object.entries(zoneImages).forEach(([zoneId, state]) => {
    const nextZoneState = { ...state };
    delete nextZoneState.file;
    nextState[zoneId] = nextZoneState;
  });

  return nextState;
};
